<template>
  <b-dropdown
    class="icon-dropdown"
    menu-class="menu-shadow text-medium icon-dropdown-menu scrollable"
    toggle-class="icon-dd-field rounded-circle border-0 flex-center"
    toggle-tag="span"
    boundary="viewport"
    no-caret
  >
    <template slot="button-content">
      <i class="flex-shrink-0" :class="{ [iconClass]: true }" :title="iconTitle"></i>
    </template>
    <b-dropdown-item
      v-for="(option, index) in options"
      :active="selected && selected.value === option.value"
      :key="index"
      class="icon-dd-item"
      @click="$emit('change', option)"
    >
      <span class="dd-item">
        <i class="checkmark-icon" v-if="selected && selected.value === option.value"></i>
        {{ option.label }}
      </span>
    </b-dropdown-item>
    <b-dropdown-item v-if="options.length === 0" disable>No option available</b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'

/**
 * This gives an icon which opens a dropdown on its click
 */
export default {
  name: 'IconDropdown',
  props: {
    /**
     *  dropdown options. It should be array of object ({value, label})
     */
    options: Array,
    /**
     * Selected option object
     */
    selected: Object,
    iconClass: {
      type: String,
      default: 'ellipsis-horizontal-icon'
    },
    iconTitle: String
  },
  components: {
    BDropdown,
    BDropdownItem
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

/deep/ .icon-dd-field.dropdown-toggle {
  background-color: $brandSecondary;
  width: 24px;
  height: 24px;
  cursor: pointer;

  &:focus {
    box-shadow: none;
  }
}

/deep/ .icon-dropdown.show .icon-dd-field,
/deep/ .icon-dd-field:active {
  background-color: $brandSecondary !important;
}

/deep/ .icon-dd-item a {
  padding-top: 8px;
  padding-bottom: 8px;
}

.dd-item {
  position: relative;
}

.checkmark-icon {
  position: absolute;
  left: -18px;
  top: 4px;
  width: 12px;
  height: 12px;
  background-size: contain;
}
/deep/ .icon-dropdown-menu {
  max-height: 350px;
  background: $documentColor;
}
</style>
